<template>
    <div class="card shadow-sm overflow-hidden">
        <div class="card-header d-flex align-items-center py-1 px-2">
            <div class="flex-grow-1">
                <strong>事項負責人</strong>
            </div>
            <button class="btn btn-sm btn-light border btn-change"
                    v-on:click="isModalChangeOwnerOpen = true">
                更改
            </button>
        </div>
        <div class="card-body p-2">
            <div class="d-flex align-items-center">
                <div class="mr-2">
                    <b-avatar size="2.5em"
                              variant="light"
                              v-bind:src="avatar">
                        <font-awesome-icon class="h-100 w-100 p-3"
                                           icon="user-tie"
                                           v-if="!avatar && owner.role === 'vending-admin'">
                        </font-awesome-icon>
                        <font-awesome-icon class="h-100 w-100 p-3"
                                           icon="user-hard-hat"
                                           v-if="!avatar && owner.role === 'vending-site-manager'">
                        </font-awesome-icon>
                    </b-avatar>
                </div>
                <div class="flex-grow-1">
                    <h6 class="font-weight-bold mb-0">
                        {{ owner.name }}
                    </h6>
                    <p class="mb-0">
                        <small>
                            {{ owner.email }}
                        </small>
                    </p>
                </div>
            </div>
        </div>

        <modal-change-owner v-bind:owner="owner"
                            v-bind:task-id="taskId"
                            v-model="isModalChangeOwnerOpen">
        </modal-change-owner>
    </div>
</template>

<script>
import { BAvatar,  } from "bootstrap-vue";
import ModalChangeOwner from "../ModalChangeOwner";
export default {
    name: "TaskOwner",
    components: {
        ModalChangeOwner,
        BAvatar,
    },
    props: {
        "owner": {
            type: Object,
        },
        "taskId": {
            type: String,
        },
    },
    data () {
        return {
            isModalChangeOwnerOpen: false,
        };
    },
    computed: {
        avatar () {
            return this.owner ?
                `${ this.$config.apiUrl }/${ this.$config.apiVersion }/user/avatar/${ this.owner.avatar }` :
                "";
        },
    },
    methods: {

    },

}
</script>

<style lang="scss" scoped>
.card-header {
    font-size: 0.9rem;
}

.btn-change {
    line-height: 1.25;
    font-size: 0.8rem;
}
</style>
